import type { AppRouteRecordRaw } from '@/types/router'
import { ROUTE_NAMES } from '@/types/router'

// 分享相关路由配置
export const shareRoutes: AppRouteRecordRaw[] = [
  {
    path: '/deck-share',
    name: ROUTE_NAMES.DECK_SHARE,
    component: () => import('@/views/share/DeckShare.vue'),
    meta: {
      titleKey: 'routeTitle.deckShare',
      keepAlive: false,
    },
  },
  {
    path: '/pack-share',
    name: ROUTE_NAMES.PACK_SHARE,
    component: () => import('@/views/share/PackShare.vue'),
    meta: {
      titleKey: 'routeTitle.packShare',
      keepAlive: false,
    },
  },
  {
    path: '/shop',
    name: ROUTE_NAMES.SHOP,
    component: () => import('@/views/share/Shop.vue'),
    meta: {
      titleKey: 'routeTitle.shop',
      keepAlive: false,
    },
  },
  {
    path: '/wish',
    name: ROUTE_NAMES.WISH,
    component: () => import('@/views/share/Wish.vue'),
    meta: {
      titleKey: 'routeTitle.wish',
      keepAlive: false,
    },
  },
  {
    path: '/dynamic-share',
    name: ROUTE_NAMES.DYNAMIC_SHARE,
    component: () => import('@/views/share/DynamicShare.vue'),
    meta: {
      titleKey: 'routeTitle.dynamicShare',
      keepAlive: false,
    },
  },
  {
    path: '/ai-news',
    name: ROUTE_NAMES.AI_NEWS,
    component: () => import('@/views/share/AINews.vue'),
    meta: {
      titleKey: 'routeTitle.aiNews',
      keepAlive: false,
    },
  },
  {
    path: '/ai-deck',
    name: ROUTE_NAMES.AI_DECK,
    component: () => import('@/views/share/AIDeck.vue'),
    meta: {
      titleKey: 'routeTitle.aiDeck',
      keepAlive: false,
    },
  },
  {
    path: '/card-album',
    name: ROUTE_NAMES.CARD_ALBUM,
    component: () => import('@/views/share/CardAlbum.vue'),
    meta: {
      titleKey: 'routeTitle.cardAlbum',
      keepAlive: false,
    },
  },
  {
    path: '/card-detail',
    name: ROUTE_NAMES.CARD_DETAIL,
    component: () => import('@/views/share/card-detail.vue'),
    meta: {
      titleKey: 'routeTitle.cardDetail',
      keepAlive: false,
    },
  },
  {
    path: '/user',
    name: ROUTE_NAMES.USER_PROFILE,
    component: () => import('@/views/share/UserProfile.vue'),
    meta: {
      titleKey: 'routeTitle.userProfile',
      keepAlive: false,
    },
  },
  {
    path: '/auction-share',
    name: ROUTE_NAMES.AUCTION_SHARE,
    component: () => import('@/views/share/AuctionShare.vue'),
    meta: {
      titleKey: 'routeTitle.auctionShare',
      keepAlive: false,
    },
  },
] 